import { Box, Button, TextField, Typography } from "@mui/material";
import { useContext, useState } from "react";
import { RequestContext } from "../../context/request.context";

const ResetPassword = ({ user, close }) => {
  const [password, setPassword] = useState("");
  const { request } = useContext(RequestContext);
  const resetPassword = async () => {
    await request(
      `/user/${user.id}/reset-password?password=${password}`,
      "PUT"
    );
    close();
  };
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
        padding: "1rem",
      }}
    >
      <Typography variant="body1">Parolni yangilash</Typography>
      <TextField
        label="Yangi Parol"
        name="password"
        fullWidth
        required
        size="small"
        defaultValue={password}
        onChange={(e) => setPassword(e.target.value)}
      />
      <Button
        type="submit"
        variant="contained"
        color="primary"
        disabled={password.length < 6}
        onClick={resetPassword}
      >
        Saqlash
      </Button>
    </Box>
  );
};

export default ResetPassword;
